/**
 * LF360-1970 — which refusals mean "there is no session", and which are just a
 * refusal.
 *
 * Both layouts ended the session on `401 || 403`, and a 403 is the answer to
 * plenty of ordinary things: a project this user is not in
 * (`FORBIDDEN_PROJECT_ACCESS`), a role that may not do this, a write refused by
 * the origin check. All of those signed the administrator out of a session that
 * was perfectly alive, and with the token in `localStorage` that at least left
 * them able to sign back in with what they had; with a cookie it is a round trip
 * through the login screen for a permission error.
 *
 * The backend says which it is. `ensureToken` answers 403 with a `message`
 * naming the token problem, and passport answers 401 when nothing usable
 * reached the route at all. Everything else is about what the caller asked for,
 * not about who they are.
 *
 * `TOKEN_ERROR` is deliberately NOT here, and it used to be. It is what the
 * backend said when the token READ failed — a database blip, a dropped
 * connection — which says nothing about the session and everything about the
 * server having a bad minute. Signing out on it produced exactly the failure
 * this ticket is about: the screen says signed out, the cookie is still good,
 * and a reload walks back in. `ensureToken` answers 500 for that now, and this
 * stays in step by not listing it either.
 *
 * A list rather than a condition spread across two components: they had already
 * drifted once, and the half that drifts is the one that leaves somebody signed
 * in.
 */
const SESSION_FAILURES = new Set(["TOKEN_DECLINED", "TOKEN_MISSING"]);

export const endsSession = (error) => {
  const status = error?.response?.status;

  // No usable credential reached the route at all.
  if (status === 401) {
    return true;
  }

  if (status !== 403) {
    return false;
  }

  return SESSION_FAILURES.has(error?.response?.data?.message);
};

export default endsSession;
